(function () {
  var PLACEHOLDER_ATTR = 'data-placeholder-set';

  // オプション名から「〇〇を選択してください」テキストを生成
  function getPlaceholderText(btn) {
    // ProductForm__SelectedValue に書き込む文字列のみ返す
    // ラベル「色:」「サイズ:」はそのまま残るので、プレースホルダーは「選択してください」だけでOK
    return '選択してください';
  }

  // カートボタンを取得
  function getCartBtn() {
    return document.querySelector('.ProductForm__AddToCart[data-action="add-to-cart"]');
  }

  // 全オプションが選択済みか判定
  // プレースホルダーが残っているボタンが1つでもあれば未選択とみなす
  function allOptionsSelected() {
    var btns = document.querySelectorAll('.ProductForm__Item[' + PLACEHOLDER_ATTR + ']');
    for (var i = 0; i < btns.length; i++) {
      var selectedEl = btns[i].querySelector('.ProductForm__SelectedValue');
      if (!selectedEl) continue;
      var val = selectedEl.textContent.trim();
      // プレースホルダーテキストのままなら未選択
      if (val === btns[i].getAttribute(PLACEHOLDER_ATTR)) return false;
    }
    return btns.length > 0 ? true : true; // オプションなし商品はそのまま
  }

  // カートボタンの有効/無効を切り替え
  function updateCartButton() {
    var btn = getCartBtn();
    if (!btn) return;

    // オプションが存在しない商品（バリアント1つ）はスキップ
    var optionBtns = document.querySelectorAll('.ProductForm__Item[' + PLACEHOLDER_ATTR + ']');
    if (optionBtns.length === 0) return;

    if (allOptionsSelected()) {
      btn.disabled = false;
      btn.style.opacity = '';
      btn.style.cursor = '';
      btn.style.pointerEvents = '';
    } else {
      btn.disabled = true;
      btn.style.opacity = '0.4';
      btn.style.cursor = 'not-allowed';
      btn.style.pointerEvents = 'none';
    }
  }

  // 各オプションボタンにプレースホルダーを設定
  function initPlaceholders() {
    var btns = document.querySelectorAll('.ProductForm__Item');
    btns.forEach(function (btn) {
      if (btn.hasAttribute(PLACEHOLDER_ATTR)) return; // 二重初期化防止

      var placeholderText = getPlaceholderText(btn);
      btn.setAttribute(PLACEHOLDER_ATTR, placeholderText);

      // SelectedValue を上書きしてプレースホルダーを表示
      var selectedEl = btn.querySelector('.ProductForm__SelectedValue');
      if (selectedEl) {
        selectedEl.textContent = placeholderText;
      }

      // hidden の variant input もリセット
      var form = btn.closest('form');
      if (form) {
        var idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = '';
      }
    });

    updateCartButton();
  }

  // ポップオーバー内の選択肢がクリックされたときに検知
  // Prestige は popover 内の li/button をクリックすると
  // ProductForm__Item の ProductForm__SelectedValue を書き換える
  function observeSelections() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (
          mutation.type === 'characterData' ||
          (mutation.type === 'childList' && mutation.target.classList &&
            mutation.target.classList.contains('ProductForm__SelectedValue'))
        ) {
          updateCartButton();
        }
      });
    });

    // .ProductForm__SelectedValue の変化を監視
    document.querySelectorAll('.ProductForm__SelectedValue').forEach(function (el) {
      observer.observe(el, { characterData: true, childList: true, subtree: true });
    });
  }

  function init() {
    initPlaceholders();
    observeSelections();
  }

  // DOMContentLoaded で実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
